import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';
import Filter from '../../../../Filters/Filter';
import TwSlider from '../../../../TwSlider';
import currencySymbol from '../../../../../helpers/currencySymbol';
import useTourFilter from '../../../../../hooks/useTourFilter';

const TourPriceFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, filters, applyFilter } = useTourFilter(tripId);
  const currencyCode = useSelector((store) => {
    const responses = tripId
      ? store.tour.tourSearches?.[tripId]?.responses
      : store.tripSearch.searchResult;
    return responses?.travelOptions?.[0]?.itinerary?.cost?.currencyCode;
  });
  const minPrice = Math.floor(filters?.minPrice || 0);
  const maxPrice = Math.ceil(filters?.maxPrice || 0);
  const [sliderValue, setSliderValue] = useState([minPrice, maxPrice]);

  useEffect(() => {
    setSliderValue([searchObj.minPrice ?? minPrice, searchObj.maxPrice ?? maxPrice]);
  }, [searchObj.minPrice, searchObj.maxPrice, minPrice, maxPrice]);

  if (!maxPrice || maxPrice <= minPrice) {
    return <></>;
  }

  const isEmpty = searchObj.minPrice === undefined && searchObj.maxPrice === undefined;

  const formatPrice = (value) => (
    <NumberFormat
      value={value}
      displayType="text"
      thousandSeparator
      decimalScale={0}
      prefix={currencySymbol(currencyCode)}
    />
  );

  const handleCommit = (event, value) => {
    applyFilter({
      minPrice: value[0] > minPrice ? value[0] : undefined,
      maxPrice: value[1] < maxPrice ? value[1] : undefined,
    });
  };

  return (
    <Filter
      label="Price"
      menuWidthClass="w-max"
      isFilterEmpty={isEmpty}
      variant={variant}
      filterMaxWidthClass="max-w-full"
      handleClear={() => applyFilter({ minPrice: undefined, maxPrice: undefined })}
      filterSpacingClass={filterSpacingClass}
    >
      <div className="px-5 pt-4 w-64">
        <div className="grid grid-cols-3 mb-1">
          <div className="text-sm text-gray-700 whitespace-no-wrap">Price:</div>
          <div className="col-span-2 text-right text-xs text-gray-700">
            {formatPrice(sliderValue[0])} - {formatPrice(sliderValue[1])}
          </div>
        </div>
        <TwSlider
          value={sliderValue}
          onChange={(event, value) => setSliderValue(value)}
          onChangeCommitted={handleCommit}
          min={minPrice}
          max={maxPrice}
        />
      </div>
    </Filter>
  );
};

TourPriceFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourPriceFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourPriceFilter;
